import { useNavigate } from 'react-router-dom';

const STEPS = [
  {
    number: '01',
    icon: 'ri-hammer-line',
    title: 'Demolition & Removal',
    desc: 'We handle all tear-out, haul-away, and disposal. No dumpster rental needed from you.',
  },
  {
    number: '02',
    icon: 'ri-tools-line',
    title: 'Prep & Subfloor Work',
    desc: 'Leveling, moisture barriers, and subfloor repairs — we fix what others skip.',
  },
  {
    number: '03',
    icon: 'ri-grid-line',
    title: 'Expert Installation',
    desc: 'Precision installation by our in-house crew. No subcontractors, no shortcuts.',
  },
  {
    number: '04',
    icon: 'ri-sparkling-line',
    title: 'Cleanup & Final Walk',
    desc: 'We leave your space spotless. Final inspection together before we call it done.',
  },
];

export default function TurnkeySection() {
  const navigate = useNavigate();

  return (
    <section className="bg-[#faf8f5] py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#c9a55a] text-xs font-bold uppercase tracking-[0.3em] mb-4">
            Full-Service Approach
          </p>
          <h2 className="text-4xl md:text-5xl font-black text-[#1c1a17] leading-tight mb-6">
            True <span className="text-[#c9a55a]">Turn-Key</span> Service
          </h2>
          <p className="text-[#6b6560] text-base leading-relaxed max-w-2xl mx-auto">
            From the first hammer swing to the final cleanup — we handle everything. 
            No coordinating multiple crews. No surprise costs. Just show up and enjoy the result.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {STEPS.map((step, idx) => (
            <div
              key={step.number}
              className="group bg-white border border-[#e5e0d8] hover:border-[#c9a55a]/40 rounded-2xl p-6 transition-all duration-300 cursor-default"
            >
              {/* Number + Icon */}
              <div className="flex items-start justify-between mb-6">
                <span className="text-[#e5e0d8] text-4xl font-black group-hover:text-[#c9a55a]/20 transition-colors duration-300">
                  {step.number}
                </span>
                <div className="w-12 h-12 flex items-center justify-center bg-[#f4f0ea] group-hover:bg-[#c9a55a]/10 rounded-xl transition-colors duration-300">
                  <i className={`${step.icon} text-[#c9a55a] text-xl`} />
                </div>
              </div>

              {/* Content */}
              <h3 className="text-[#1c1a17] font-bold text-lg mb-3">{step.title}</h3>
              <p className="text-[#6b6560] text-sm leading-relaxed">{step.desc}</p>

              {/* Connector line (hidden on last item and mobile) */}
              {idx < STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-[2px] bg-[#e5e0d8]" />
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="bg-[#1c1a17] rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-6">
            <div className="w-16 h-16 flex items-center justify-center bg-[#c9a55a]/15 rounded-2xl flex-shrink-0">
              <i className="ri-home-smile-line text-[#c9a55a] text-3xl" />
            </div>
            <div>
              <h3 className="text-white font-bold text-xl mb-1">Ready for a stress-free renovation?</h3>
              <p className="text-[#a09890] text-sm">One call. One crew. One beautiful result.</p>
            </div>
          </div>
          <button
            type="button"
            onClick={() => navigate('/contact')}
            className="bg-[#c9a55a] hover:bg-[#b8943f] text-white font-bold text-sm px-8 py-4 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer flex-shrink-0"
          >
            Start Your Project
          </button>
        </div>
      </div>
    </section>
  );
}
